import { NumericFormatProps } from 'react-number-format';

export const NUMBER_FORMAT_OPTIONS: NumericFormatProps = {
    thousandSeparator: true,
    decimalScale: 2,
    fixedDecimalScale: true
};
